import { Fragment } from "react";
export const Loader = () => {
  return (
    <Fragment>
        <div className="loader-container">
        <div className="btn--loading">
          <span>
            <b></b>
            <b></b>
            <b></b>
            <b></b>
            <b></b>
            <b></b>
          </span>
        </div>
        </div>
    </Fragment>
  );
};
export const IconLoader=()=>{
}
